import React from 'react'
import styled from 'styled-components'

/**
 * ヘルプモーダルのハイライト制御用コンポーネント
 */
const ModalInputWrap: React.FC<InputWrapProps> = (props) => {
  const { inputKey, isInvalid, width, children, setShowAlert } = props
  // isInvalidは入力変更中、常に変化する
  // フォーカス時の状態を保持
  const [memoIsInvalid, setMemoIsInvalid] = React.useState(isInvalid ?? false)
  // エラーから正常値になったことを保持（入力中）
  const [beCollectFlg, setBeCollectFlg] = React.useState(false)
  // バリデーションのハイライト管理ステート
  const [isHighlight, setIsHighlight] = React.useState(isInvalid ?? false)

  // onblurステートを固定
  const handleOnblur = (): void => {
    // 現在の入力値のバリデーション状況を保持
    setMemoIsInvalid(isInvalid)
    setIsHighlight(isInvalid)
    setShowAlert(isInvalid, inputKey)
    // エラーから正常値になることを検知するためfalseで初期化
    setBeCollectFlg(false)
  }
  React.useEffect(() => {
    if (!beCollectFlg && memoIsInvalid) {
      if (!isInvalid) {
        setBeCollectFlg(true)
      }
      setIsHighlight(isInvalid)
      setShowAlert(isInvalid, inputKey)
    }
  }, [isInvalid])
  return (
    <StyledInputWrap
      width={width}
      onBlur={handleOnblur}
      isInvalid={isHighlight}
    >
      {children}
    </StyledInputWrap>
  )
}

export type InputWrapProps = {
  children: React.ReactNode
  inputKey: string
  setShowAlert: (isInvalid: boolean, key: string) => void
  width: string
  isInvalid: boolean
}

export const StyledInputWrap = styled.div<{
  width?: string
  isInvalid: boolean
}>`
  ${(props): string =>
    `
      display:flex;
      width:${props.width};
      background: ${
        props.isInvalid
          ? 'var(--color-invalid-background)'
          : 'var(--color-background)'
      };
    `}
`

export default ModalInputWrap
